import React from "react";

import "../css/CloudComputingPage.css";
import CloudComputingPhotoLoader from "./CloudComputingPhotoLoader";
import CloudComputingVideoCard_1 from "./CloudComputingVideoCard_1";
import Chatbot from "./Chatbot";

const CloudComputingPage = () => {
  return (
    <div className="cloud-computing-page body white-letter centered-text">
      I think all computational systems are moving to the Cloud, large Data
      availability is getting more and more important as AI progress and if you
      want to take advantage I think the only way to do it is learing how to use
      the Cloud. I granted my AWS Practitioner Certified and I'm currently
      studying for the AWS AI Practioner and afer that I would become an AWS
      DevOps certified.
      <div className="cloud-computing-page my-rows">
        <CloudComputingPhotoLoader />
        <CloudComputingVideoCard_1 />
      </div>
      <div className="cloud-computing-page my-rows">
        <Chatbot />
      </div>
    </div>
  );
};

export default CloudComputingPage;
